import React from 'react'
import { Box, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { 
  DataGrid,
  GridToolbar,
  GridRowParams,
    GridActionsCellItem
 } from '@mui/x-data-grid';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
// import useAuth from '../auth/useAuth';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { useNavigate } from 'react-router-dom';


export const AllAssociations = () => {
    // const apiPrivate = useApiPrivate();
    // const auth = useAuth();
    const [theme, colorMode] = useMode();
    const [apiResponse, setApiResponse] = useState({});
    const [join, setJoin] = useState({})
    const themee = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
   


    useEffect(() => {
        const fetchAllAsso = async () => {
              try {
                const response = await api.get("/association/", {
                  headers :{
                    Authorization: 'Bearer '+ fetchToken()
                  }
                }); 
                
                const associationForm = response.data;
                setApiResponse(associationForm);
                
              } catch (error) {
                console.log(error.response);
              }
            }

          fetchAllAsso();

      }, [])

    
      

      


const columns = [
    {
    
        field: "Association_id",
        headerName: "ID",
        flex: 1,
        cellClassName: "name-column--cell",
      },
      {

        field: "Association_name",
        headerName: "Savings Group Name",
        flex: 1,
        cellClassName: "name-column--cell",
      },
      {
        field: "Association_Type",
        headerName: "Savings Group Type",
        flex: 1,
      },
      {
        field: "Facilitator_username",
        headerName: "Facilitator",
        flex: 1,
      },
      {
        field: "community_name",
        headerName: "Community",
        flex: 1,
      },
      {
        field: "open_date",
        headerName: "Date Created",
        flex: 1,
      },
      {
        field: 'actions',
        type: 'actions',
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
          icon={<LaunchOutlinedIcon />}
          onClick={() => handleClick(params.row.Association_id)} 
          label="Open"
    />,
        ]
      }
      
    ];

    const handleClick = (associationId) => {
      try {
         api.get(`association/${associationId}`,{
          headers :{
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
          if (response.status === 200 && response.data) {
            navigate('/association/', { state: { responseData: response.data } })
          };
        });
        
      } 
      catch(error){
      console.log(error )
    };
  };
      

        

  return (
      <div className="app">
        <main className="content">
            <Box sx={{ m:5 }}>
              {/* HEADER */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Savings Group" subtitle="All Savings Groups" />
                </Box>

                <Box
                    m="40px 0 0 0"
                    height="75vh"
                    paddingBottom="35px"
                    sx={{
                    //   "& .MuiDataGrid-root": {
                    //     border: "none",
                    //   },
                    //   "& .MuiDataGrid-cell": {
                    //     borderBottom: "none",
                    //   },
                    //   "& .name-column--cell": {
                    //     color: colors.blueAccent[100],
                    //   },
                    //   "& .MuiDataGrid-columnHeaders": {
                    //     color: "white",
                    //     backgroundColor: colors.grey[500],
                    //     borderBottom: "none",
                    //   },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                    //   "& .MuiDataGrid-footerContainer": {
                    //     borderTop: "none",
                    //     backgroundColor: colors.grey[400],
                    //   },
                    //   "& .MuiCheckbox-root": {
                    //     color: `${colors.greenAccent[200]} !important`,
                    //   },import { api } from './../api';

                    }}
                  >
                    <DataGrid
                        rows={apiResponse}
                        columns={columns}
                        checkboxSelection
                        getRowId={(row) => row.Association_id}
                        slots={{ toolbar: GridToolbar }}
                    />
                  </Box>

            </Box>
          </main>
        </div>
  )
}